import { render, staticRenderFns } from "./Game6-5.vue?vue&type=template&id=cbcca98e&scoped=true&"
import script from "./Game6-5.vue?vue&type=script&lang=js&"
export * from "./Game6-5.vue?vue&type=script&lang=js&"
import style0 from "./Game6-5.vue?vue&type=style&index=0&id=cbcca98e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbcca98e",
  null
  
)

export default component.exports